import templateUrl from './search-result.html';
import clone from 'lodash/clone';

export const searchResultComponent = {
    templateUrl,

    bindings: {
        details: '<',
        searchKey: '@'
    },

    controller: class searchResultComponent {
        constructor($anchorScroll, $state, SearchResultService, ApiService, SlugService) {
            'ngInject';

            this.$anchorScroll = $anchorScroll;
            this.$state = $state;
            this.searchResultService = SearchResultService;
            this.apiService = ApiService;
            this.slugService = SlugService;
        }

        $onInit() {
            this.currentPage = 1;
            this.itemPerPage = 10;
            this.totalItems = this.details.count;
            this.pageContentLimit = this.itemPerPage;
            this.pageId = this.currentPage;
            this.pageResultStartIndex = (this.itemPerPage * (this.currentPage - 1) + 1);
        }

        onSearch(searchKey) {
            this.$state.go('SearchResults', {
                searchKey
            });
        }

        onChange(pageNumber) {
            this.currentPage = pageNumber;
            this.pageId = this.currentPage;
            this.pageResultStartIndex = (this.itemPerPage * (this.currentPage - 1) + 1);
            this.searchResultService.getSearchResults(this.searchKey, this.pageContentLimit, this.pageId)
                .then(details => {
                    this.details = details;
                    this.$anchorScroll(() => $location.hash());
                });
        }

        routeToDetailsPageByContentId(contentId, slug) {
            const url = this._getDetailsPageUrlByContentId(contentId, slug);
            
            this.$state.go('DynamicMenus', {
                url
            });
        }

        _getDetailsPageUrlByContentId(contentId, slug) {
            return this.slugService.getDetailsPageUrlByContentId(contentId, slug);
        }

        _getFileReportPath({ pdf, url }) {
            return pdf ? this.apiService.getResourceUrl(`files/pdf/${pdf}`) : url;
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/search-result/search-result.component.js